import dynamic from "next/dynamic";
import Hero from "../components/organisms/common/Hero";
import CutoutFeaturedImage from "../components/organisms/common/CutoutFeaturedImage";
import Theme from "../components/Theme";
import FeaturedImage from "../components/organisms/common/FeaturedImage";
import PricingPlanWithTitle from "../components/organisms/common/PricingPlanWithTitle";
import AppStorage from "../components/AppStorage";
const TpWidget = dynamic(() => import("../components/atoms/document/TpWidget"));
const WideCTA = dynamic(() => import("../components/organisms/common/WideCTA"));
const People = dynamic(() => import("../components/organisms/common/People"));
const Masonry = dynamic(() => import("../components/organisms/common/Masonry"));
const CtaWithChecklist = dynamic(() =>
  import("../components/organisms/common/CtaWithChecklist")
);
export async function getStaticProps(ctx) {
  let allData = {};
  const { locale } = ctx;
  // Page Route
  const route = "free-business-website";

  // Fetch data for respective pages
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );

  const pricingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/pricing.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();
  allData.pricing = await pricingResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };
  const pricing = {
    pricing: allData.pricing,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...pricing,
    ...allData.marketing,
    ...allData.content,
  };

  // Return to the component
  return {
    props: {
      data,
    },
  };
}

export default function Page({ data, nonce }) {
  const { seo, header, footer, pricing, content } = data;
  return (
    <Theme
      header={header}
      footer={footer}
      seo={seo}
      nonce={nonce}
      className="pricing-layout landing-page landing-page-free-business-website has-pricing-comments"
    >
      <AppStorage pageName="Others - free-business-website" />
      <Hero data={content.hero} />
      <CutoutFeaturedImage
        data={content.cutoutFeaturedImage}
        className="lg:pb-10 md:pb-7"
      />
      <CtaWithChecklist
        data={content.ctaWithChecklist}
        className="lg:pb-20 md:pb-10"
      />
      <Masonry
        data={content.masonry}
        className="lg:mb-20 md:mb-10 bg-offset-top"
      />
      <section>
        {content.featuredImageSections.map((item, index) => {
          return (
            <FeaturedImage
              data={item}
              key={index}
              imageAlign={item.image.align}
            />
          );
        })}
      </section>
      <PricingPlanWithTitle
        heading={content.pricingPlan}
        pricing={pricing}
        initialPlanType="annual-billing-plan"
        className="lg:pb-10 bg-offset-bottom"
      />
      <People className="bg-light" />
      <WideCTA data={content.wideCTA} />
      <TpWidget />
    </Theme>
  );
}
